import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-44100cc4")

_pushScopeId("data-v-44100cc4")
const _hoisted_1 = { class: "bp-font-text mt-4 mb-4" }
const _hoisted_2 = { class: "mt-6 space-y-4" }
const _hoisted_3 = {
  key: 0,
  class: "text-xl text-center leading-6 font-medium text-bp-dark dark:text-gray-500 mb-4"
}
const _hoisted_4 = {
  key: 1,
  class: "text-sm text-center leading-6 text-bp-dark dark:text-gray-500 mb-0"
}
const _hoisted_5 = { class: "pb-4" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 3,
  id: "modal-SubscribeStatusButton",
  class: "text-xl text-center leading-6 font-medium text-bp-dark dark:text-gray-500 mb-4"
}
const _hoisted_9 = {
  key: 0,
  class: "mb-6 md:mb-12"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DangerAlert = _resolveComponent("DangerAlert")
  const _component_DefaultSpinner = _resolveComponent("DefaultSpinner")
  const _component_ActivateMailChannel = _resolveComponent("ActivateMailChannel")
  const _component_ActivateTelegramChannel = _resolveComponent("ActivateTelegramChannel")
  const _component_DefaultButton = _resolveComponent("DefaultButton")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", null, [
        _createVNode(_component_DangerAlert, {
          class: "mt-4",
          "error-message": $setup.errorMessage,
          "error-title": $setup.errorTitle,
          "show-title": true
        }, null, 8, ["error-message", "error-title"]),
        _createVNode("div", _hoisted_2, [
          ($setup.isMailChannelSelected())
            ? (_openBlock(), _createBlock("p", _hoisted_3, "Verification Code"))
            : _createCommentVNode("", true),
          ($setup.isMailChannelSelected())
            ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.$t("modal.SubscribeDialog.confirmInfoMail")), 1))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode("form", _hoisted_5, [
            ($setup.isMailChannelSelected())
              ? (_openBlock(), _createBlock("span", _hoisted_6, [
                  _createVNode(_component_DefaultSpinner, {
                    id: "subscribeSpinner",
                    "show-spinner": $setup.isVerificationInProgress,
                    "show-spinner-alternative-text": false,
                    "spinner-size": "h-7 w-7"
                  }, null, 8, ["show-spinner"])
                ]))
              : _createCommentVNode("", true),
            ($setup.isMailChannelSelected())
              ? (_openBlock(), _createBlock(_component_ActivateMailChannel, {
                  key: 1,
                  data: $props.subscriptionData,
                  onOnSuccessActivation: $setup.activateChannel,
                  onOnError: $setup.errorOnActivation,
                  onShowLoading: _cache[1] || (_cache[1] = ($event: any) => {$setup.isVerificationInProgress = true; $setup.errorMessage = ''; $setup.errorTitle=''}),
                  onHideLoading: _cache[2] || (_cache[2] = ($event: any) => ($setup.isVerificationInProgress = false))
                }, null, 8, ["data", "onOnSuccessActivation", "onOnError"]))
              : _createCommentVNode("", true),
            ($setup.isTelegramChannelSelected())
              ? (_openBlock(), _createBlock(_component_ActivateTelegramChannel, {
                  key: 2,
                  data: $props.subscriptionData,
                  onOnSuccessActivation: $setup.activateChannel,
                  onOnError: $setup.errorOnActivation
                }, null, 8, ["data", "onOnSuccessActivation", "onOnError"]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, !$setup.showActiveAnimation]
          ]),
          ($setup.isTelegramChannelSelected())
            ? (_openBlock(), _createBlock("span", _hoisted_7, [
                _createVNode(_component_DefaultSpinner, {
                  id: "subscribeSpinner",
                  "show-spinner": $setup.isVerificationInProgress,
                  "show-spinner-alternative-text": false,
                  "spinner-size": "h-7 w-7"
                }, null, 8, ["show-spinner"])
              ]))
            : _createCommentVNode("", true),
          ($setup.isTelegramChannelSelected())
            ? (_openBlock(), _createBlock("h3", _hoisted_8, _toDisplayString(_ctx.$t("modal.SubscribeDialog.confirmInfoTelegram")), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    ($setup.isTelegramChannelSelected())
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode(_component_DefaultButton, {
            "button-text": _ctx.$t('modal.SubscribeDialog.goForward'),
            "button-color": "bg-bp-light",
            "button-hover": "hover:bg-bp-light",
            "button-width": "w-auto",
            "button-x-margin": "mx-auto",
            "center-button": "mb-6",
            "button-type": "submit",
            "custom-css": "disabled:opacity-50 ",
            disabled: ""
          }, null, 8, ["button-text"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
})